<template>
  <div>
    <v-tabs v-model="tab" background-color="primary" dark>
      <v-tab v-for="item in items" :key="item.value" :value="item.value">
        <v-icon style="margin-right: 7px">{{ item.icon }}</v-icon>
        {{ item.tab }}
      </v-tab>
    </v-tabs>

    <v-tabs-items v-model="tab" :touchless="true">
      <v-tab-item v-for="item in items" :key="item.value">
        <div class="px-2">
          <component v-if="tab === item.value" :is="item.component"></component>
        </div>
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>

<script>
import {
  ReportMealsTabMeals,
  ReportMealsTabOrders,
  ReportMealsTabPackages,
  ReportMealsTabMealEmployee,
  ReportMealsTabFoods,
  ReportMealsTabTaken,
  ReportMealsTabEmployees,
  ReportMealsTabTakenMeals,
  ReportMealsTabReservedMeals,
  ReportMealsTabRestaurants,
  ReportMealsTabGroceries,
  ReportMealsTabNonRegistered,
} from "@/components/report/meals";

export default {
  props: {
    activeTab: {
      type: Number,
      default: 0,
    }
  },
  data: () => ({
    tab: null,
  }),
  computed: {
    items() {
      return [
        {
          tab: this.$t("groceri"),
          icon: "mdi-corn",
          component: ReportMealsTabGroceries,
          value: 0,
        },
        {
          tab: this.$t("meals_main"),
          icon: "mdi-food-drumstick",
          component: ReportMealsTabFoods,
          value: 1,
        },
        {
          tab: this.$t("meals"),
          icon: "mdi-bowl-mix",
          component: ReportMealsTabMeals,
          value: 2,
        },
        {
          tab: this.$t("warehouse.ordered"),
          icon: "mdi-grid",
          component: ReportMealsTabOrders,
          value: 3,
        },
        {
          tab: this.$t("pak"),
          icon: "mdi-shopping-outline",
          component: ReportMealsTabPackages,
          value: 4,
        },
        {
          tab: this.$t("meal_worker"),
          icon: "mdi-format-list-bulleted-type",
          component: ReportMealsTabMealEmployee,
          value: 5,
        },
        {
          tab: this.$t("taken"),
          icon: "mdi-truck-delivery",
          component: ReportMealsTabTaken,
          value: 6,
        },
        {
          tab: this.$t("employees"),
          icon: "mdi-account",
          component: ReportMealsTabEmployees,
          value: 7,
        },
        {
          tab: this.$t("t_o"),
          icon: "mdi-check-underline-circle",
          component: ReportMealsTabTakenMeals,
          value: 8,
        },
        {
          tab: this.$t("r_o"),
          icon: "mdi-shopping-outline",
          component: ReportMealsTabReservedMeals,
          value: 9,
        },
        {
          tab: this.$t("un"),
          icon: "mdi-shopping-outline",
          component: ReportMealsTabNonRegistered,
          value: 10,
        },
        {
          tab: this.$t("restaurants"),
          icon: "mdi-shopping-outline",
          component: ReportMealsTabRestaurants,
          value: 11,
        },
      ];
    },
  },
  watch: {
    activeTab(newVal) {
      this.tab = newVal;
    },
  },
};
</script>

<style>
.v-slide-group__prev {
  display: none !important;
}
</style>
